import { z } from 'zod'
import type { AsyncFn } from '../common'
import type { ForCompany, ForCompanyUser } from '../domain/Company/Company'
import type { MaintenancePlanGuidContainer } from '../domain/MaintenancePlans/MaintenancePlanTypes'
import type { RepeatVisitMonthsContext, VisitMonthChange } from '../domain/MaintenancePlans/RepeatVisitMonths'
import { guidSchema } from './_common'

export const repeatMaintenancePlanVisitMonthsSchema = z.object({
  maintenancePlanGuid: guidSchema,
  snapshotToken: z.string().regex(/^[a-f0-9]{64}$/),
  months: z.array(z.number().int().min(0).max(11)).min(1).max(100),
})

export type MaintenancePlanVisitMonthsSnapshot = {
  context: RepeatVisitMonthsContext | null
  snapshotToken: string
}

export type ReadMaintenancePlanVisitMonths = AsyncFn<
  ForCompany<MaintenancePlanGuidContainer>,
  MaintenancePlanVisitMonthsSnapshot
>
export type RepeatMaintenancePlanVisitMonths = AsyncFn<
  ForCompanyUser<z.infer<typeof repeatMaintenancePlanVisitMonthsSchema>>,
  { changes: VisitMonthChange[] }
>

export type MaintenancePlanVisitMonthsService = {
  read: ReadMaintenancePlanVisitMonths
  apply: RepeatMaintenancePlanVisitMonths
}
